export const selectBalancesLoadingFlag = (state: AppModel) => {
    return state.balances.isFetching;
};
